import React from 'react'
import PropTypes from 'prop-types'
import { withRedux, withUser } from '../reduxContainer'
import { connect } from 'react-redux'
import PlanEntriesList from '../planEntryList/PlanEntriesList'
import { getFavorites } from '../../redux/selectors/favorite'
import {
  fetchFavorites,
  setFavoritesOrder,
  clearFavorites,
  favoriteRemoved,
  clearFavoritesOrder
} from '../../redux/actions/favorite'
import FavoriteDeleteUndo from './FavoriteDeleteUndo'
import './FavoritesList.scss'
import EmptyState from '../EmptyState'

const FAVORITE_UNDO_FADE_OUT_TIME = 10000

class FavoritesList extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      deletedFavorite: null
    }

    this.fetchMoreFavorites = this.fetchMoreFavorites.bind(this)
    this.unfavorite = this.unfavorite.bind(this)
    this.hideUndoBar = this.hideUndoBar.bind(this)
    this.reorderFavorites = this.reorderFavorites.bind(this)
  }

  componentDidMount () {
    this.props.fetchFavorites()
  }

  hideUndoBar () {
    this.setState({ deletedFavorite: null })
  }

  fetchMoreFavorites () {
    this.props.fetchFavorites()
  }

  unfavorite (favoriteId) {
    const deletedFavorite = this.props.favorites
      .filter(favorite => favorite.id === favoriteId)
      .first()
    this.props.removeFavorite(favoriteId)
    this.setState({ deletedFavorite })

    setTimeout(() => {
      this.setState({ deletedFavorite: null })
    }, FAVORITE_UNDO_FADE_OUT_TIME)
  }

  generateEntriesArray () {
    return this.props.favorites.toModelArray().map(favorite => ({
      obj: favorite.planEntry,
      id: favorite.id,
      createdAt: favorite.createdAt
    }))
  }

  reorderFavorites (direction, field) {
    if (direction === 'DEFAULT') {
      this.props.clearFavoritesOrder()
    } else {
      this.props.setFavoritesOrder({ direction, order: field })
    }

    this.props.clearFavorites()
    this.props.fetchFavorites()
  }

  render () {
    const entries = this.generateEntriesArray()

    let favoritesUndoClass = 'FavoritesList__undo'
    let deleteUndo
    if (this.state.deletedFavorite) {
      favoritesUndoClass += ' FavoritesList__undo--active'
      deleteUndo = (
        <FavoriteDeleteUndo
          favorite={this.state.deletedFavorite}
          onAdded={this.hideUndoBar}
        />
      )
    }

    let listContent
    if (!this.props.loading && this.props.favorites.count() === 0) {
      listContent = (
        <EmptyState
          caption='You haven’t saved any classes yet'
          link='/class-finder'
          linkCaption='Find a class'
        />
      )
    } else {
      listContent = (
        <React.Fragment>
          <div className={favoritesUndoClass}>{deleteUndo}</div>
          <PlanEntriesList
            autopaginate={false}
            onFetchMoreEntries={this.fetchMoreFavorites}
            entries={entries}
            totalPlanEntries={this.props.totalFavorites}
            favoritable
            onDeleted={this.unfavorite}
            isLoading={this.props.loading}
            onReorder={this.reorderFavorites}
            orderBy={this.props.orderBy}
            includeDates
          />
        </React.Fragment>
      )
    }

    return <div className='FavoritesList'>{listContent}</div>
  }
}

FavoritesList.defaultProps = {
  favorites: []
}

FavoritesList.propTypes = {
  favorites: PropTypes.object,
  fetchFavorites: PropTypes.func,
  loading: PropTypes.bool,
  removeFavorite: PropTypes.func,
  totalFavorites: PropTypes.number,
  clearFavorites: PropTypes.func,
  setFavoritesOrder: PropTypes.func,
  clearFavoritesOrder: PropTypes.func,
  orderBy: PropTypes.string
}

const mapStateToProps = state => {
  return {
    favorites: getFavorites(state),
    loading: state.ui.favorites.loading,
    totalFavorites: parseInt(state.ui.favorites.total),
    orderBy: state.ui.favorites.orderInfo.order
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchFavorites: reloadAll => {
      dispatch(fetchFavorites(reloadAll))
    },
    setFavoritesOrder: orderInfo => {
      dispatch(setFavoritesOrder(orderInfo))
    },
    clearFavorites: () => {
      dispatch(clearFavorites())
    },
    removeFavorite: favoriteId => {
      dispatch(favoriteRemoved(favoriteId))
    },
    clearFavoritesOrder: () => {
      dispatch(clearFavoritesOrder())
    }
  }
}

export default withRedux(
  withUser(connect(mapStateToProps, mapDispatchToProps)(FavoritesList))
)
